import React from 'react';
import Icon from '../../../components/AppIcon';
import FAQItem from './FAQItem';

const FAQCategory = ({ category, isExpanded, onToggle }) => {
  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 md:p-6 hover:bg-accent/50 transition-colors"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="HelpCircle" size={20} className="text-primary" />
          </div>
          <h2 className="text-lg md:text-xl font-semibold text-foreground">
            {category?.title}
          </h2>
          <span className="text-sm text-muted-foreground">({category?.questions?.length})</span>
        </div>
        <Icon 
          name={isExpanded ? "ChevronUp" : "ChevronDown"} 
          size={20} 
          className="text-muted-foreground transition-transform"
        />
      </button>
      {isExpanded && (
        <div className="border-t border-border">
          {category?.questions?.map((question, index) => (
            <FAQItem 
              key={question?.id} 
              question={question}
              isLast={index === category?.questions?.length - 1}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default FAQCategory;